import { MealEntity } from './mealEntity';
import { ChildId } from './valueObjects/childId';
import { MealContent } from './valueObjects/mealContent';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';

import type { MealPropsPvt, MealPropsPub } from './mealEntity';
import type { EntityPubNotNullType } from '@/domain/entityPub';
import type { MealJson, MealJsonPub, MealJsonPvt } from '@/types/domain/meal/entities/mealEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * 食事ファクトリ
 */
export class MealFactory extends FactoryPub<
  MealEntity,
  MealPropsPvt,
  MealJsonPvt,
  MealPropsPub,
  MealJsonPub
> {
  /**
   * 比較する
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePub = (
    a: MealJson,
    b: MealJson,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: MealPropsPvt,
    propsPub: EntityPubNotNullType<MealPropsPub>,
  ): MealEntity {
    return new MealEntity(props, propsPub);
  }

  /**
   * 公開データからエンティティを生成する
   * @param json 公開データ
   * @returns 食事エンティティ
   */
  createFromEntityDataPub(json: MealJson): MealEntity {
    return new MealEntity({
      parentId: ParentId.create(json.data.parentId),
      childId: ChildId.create(json.data.childId),
      measurerId: MeasurerId.create(json.data.measurerId),
      measurerType: MeasurerType.create(json.data.measurerType),
      measureDateTime: MeasureDateTime.create(new Date(json.data.measureDateTime)),
      mealContent: MealContent.create(json.data.mealContent),
    }, {
      sendId: json.pub.sendId,
      replyId: json.pub.replyId,
      data: {},
    });
  }
}
